import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { IoArrowBack, IoBag } from 'react-icons/io5'

import Input from '@/components/forms/Input/Input'
import Button from '@/components/common/Button/Button'
import Spinner from '@/components/common/Spinner/Spinner'
import useAuthStore from '@/stores/AuthStore'
import routes from '@/routes/routes'

import './VerifyEmail.css'

const VerifyEmail = () => {
    const navigate = useNavigate()
    const { verifyConfirmationCode, isLoading, isLogged } = useAuthStore()
    const { t } = useTranslation('common')

    const [code, setCode] = useState('')

    useEffect(() => {
        if (isLogged) {
            navigate(routes.home)
        }
    }, [isLogged])

    const validateCode = (code: string) => {
        if (!code || code.length !== 6) {
            return { isValid: false, message: 'Please enter a 6-digit verification code' }
        }
        
        if (!/^\d{6}$/.test(code)) {
            return { isValid: false, message: 'Code must contain only numbers' }
        }
        
        return { isValid: true, message: '' }
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault()

        const validation = validateCode(code)
        if (!validation.isValid) {
            toast.error(validation.message)
            return
        }

        try {
            const success = await verifyConfirmationCode(code)
            if (success) {
                navigate(routes.login)
                return;
            }
        } catch (error) {
            toast.error('Verification failed')
            console.error('Verification error:', error)
        }
    }

    return (
        <div className="auth_page">
            <div className="auth_container">
                <div className="auth_header">
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => navigate(routes.login)}
                    >
                        <IoArrowBack size={16} />
                        Back to Login
                    </Button>
                </div>

                <div className="auth_card">
                    <div className="auth_brand">
                        <div className="brand_logo">
                            <IoBag size={32} />
                        </div>
                        <h1>{t('login_verify_email')}</h1>
                        <p>Ingrese el código de verificación enviado a su correo electrónico. Revise su carpeta de spam si no lo encuentra.</p>
                    </div>

                    <form className="auth_form" onSubmit={handleSubmit}>
                        <Input
                            name="code"
                            type="text"
                            value={code}
                            setValue={setCode}
                            label="Código de verificación"
                            placeholder="123456"
                            maxLength={6}
                        />

                        <Button
                            variant="primary"
                            size="lg"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? <Spinner variant="secondary" size="sm" /> : 'Verificar'}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default VerifyEmail
